export default __webpack_public_path__ + "8f446b386d6210378636576cea38faed.png";